import {
  combineValidators, required, isPostcodeFormat, isPostcodeInRidderkerk, isStreetAddress, isEmail, isPhone,
  noValidation, isValidString
} from "../Validators";

export const createBasketFormScheme = (deliveryRequired: boolean) => {
  return {
    email: combineValidators(required, isEmail, isValidString),
    phone: combineValidators(required, isPhone),
    firstName: combineValidators(required, isValidString),
    lastName: combineValidators(required, isValidString),
    postcode: deliveryRequired
      ? combineValidators(required, isPostcodeFormat, isPostcodeInRidderkerk)
      : noValidation,
    address: deliveryRequired
      ? combineValidators(required, isStreetAddress, isValidString)
      : noValidation,
  } as const;
};

